import React, { Component } from 'react';
import { Button, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';
import ChargesSummary from 'components/ChargesSummary';

const SummaryButton = styled(Button)`
  color: ${props => props.theme.roomList.link.color};
  font-weight: bold;
  text-decoration: underline;
  padding: 0;
  margin: 0.5em 0;

  &:hover {
    color: ${props => props.theme.h5.color};
  }

  &:focus {
    box-shadow: ${props => props.theme.forms.input.focusOutline};
  }
`;

const StyledPopover = styled(Popover)`
  box-shadow: 0 0 15px #888;

  .popover {
    max-width: none;
  }

  .popover-header {
    font-size: 1.4em;
    color: ${props => props.theme.h5.color};
  }

  .popover-body {
    padding: 0;
    font-size: 1.2em;
    max-height: 60vh;
    overflow-y: auto;
    scrollbar-color: #888 #f1f1f1;

    ::-webkit-scrollbar {
      width: 0.25em;
    }
    ::-webkit-scrollbar-track {
      background: #f1f1f1;
    }
    ::-webkit-scrollbar-thumb {
      background: #888;
    }
    ::-webkit-scrollbar-thumb:hover {
      background: #f1f1f1;
    }

    h5 {
      color: ${props => props.theme.h5.color};
      margin: 0;
    }
  }
`;

export class SummaryPopover extends Component {
  constructor(props) {
    super(props);

    this.state = {
      summaryPopoverOpen: false
    };
  }

  toggleSummaryPopover = () => {
    const { summaryPopoverOpen } = this.state;

    this.setState({
      summaryPopoverOpen: !summaryPopoverOpen
    });
  };

  render() {
    const { summaryPopoverOpen } = this.state;
    const {
      index,
      room,
      nightlyAverage,
      originalSubtotal,
      subTotal
    } = this.props;

    return (
      <React.Fragment>
        <SummaryButton
          color="link"
          id={`popoverTrigger${index}`}
          onClick={this.toggleSummaryPopover}
        >
          Summary
        </SummaryButton>
        <br />
        <StyledPopover
          trigger="hover"
          target={`popoverTrigger${index}`}
          placement="left"
          modifiers={{ flip: { behavior: ['bottom'] } }}
          isOpen={summaryPopoverOpen}
          toggle={this.toggleSummaryPopover}
        >
          <PopoverHeader>SUMMARY</PopoverHeader>
          <PopoverBody>
            <ChargesSummary
              room={room}
              nightlyAverage={nightlyAverage}
              subTotal={subTotal}
              originalSubtotal={originalSubtotal}
            />
          </PopoverBody>
        </StyledPopover>
      </React.Fragment>
    );
  }
}

SummaryPopover.propTypes = {
  index: PropTypes.number,
  room: PropTypes.object,
  nightlyAverage: PropTypes.number,
  originalSubtotal: PropTypes.number,
  subTotal: PropTypes.number
};

export default SummaryPopover;
